<template>
  <section :id="id" class="blog-post">
    <h2 class="title">{{title}}</h2>
    <div class="post-content">
      <Markdown :source="content" />
      <div class="social-sharing">
        <SocialSharing
          :url="shareUrl"
          :title="title"
          :hashtags="tags"
          :twitter-user="_watzon"
          inline-template>
          <div>
            <network network="email">
              <fa :icon="['fas', 'envelope']"/>
            </network>
            <network network="linkedin">
              <fa :icon="['fab', 'linkedin']"/>
            </network>
            <network network="pinterest">
              <fa :icon="['fab', 'pinterest']"/>
            </network>
            <network network="twitter">
              <fa :icon="['fab', 'twitter']"/>
            </network>
            <network network="telegram">
              <fa :icon="['fab', 'telegram']"/>
            </network>
            <network network="facebook">
              <fa :icon="['fab', 'facebook']"/>
            </network>
            <network network="vk">
              <fa :icon="['fab', 'vk']"/>
            </network>
            <network network="weibo">
              <fa :icon="['fab', 'weibo']"/>
            </network>
            <network network="pinterest">
              <fa :icon="['fab', 'pinterest']"/>
            </network>
          </div>
        </SocialSharing>
      </div>
    </div>
    <div class="meta">
      <span class="date">
        This was posted on {{formattedDate}} and due to the nature of technology details may have changed since.
        If you find an error or something needs to be updated, feel free to file an issue
        <a href="https://github.com/watzon/watzon.tech-contents/issues" target="_blank">here</a>.
      </span>
    </div>
  </section>
</template>

<style lang="stylus">

</style>

<script>
import Markdown from '../components/Markdown'
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import SocialSharing from 'vue-social-sharing'

export default {
  computed: {
    ...mapState(['blogPosts']),
    id () {
      return this.$route.params.id
    },
    formattedDate () {
      const date = moment(this.blogPost.data.date)
      return date.format('MMMM Do, YYYY')
    },
    blogPost () {
      return this.blogPosts[this.id]
    },
    content () {
      return this.blogPost.content
    },
    title () {
      return this.blogPost.data.title
    },
    tags () {
      return this.blogPost.data.tags || ''
    },
    shareUrl () {
      return `https://watzon.tech/blog/${this.id}`
    }
  },
  methods: {
    ...mapActions(['loadBlogPosts'])
  },
  mounted () {
    return this.loadBlogPosts()
  },
  components: {
    Markdown,
    SocialSharing
  }
}
</script>
